import { Checkbox, CheckboxProps, withStyles } from '@material-ui/core';
import { CSSProperties } from 'react';

const GreenCheckbox = withStyles({
  root: {
    color: '#33820D',
    '&$checked': {
      color: '#33820D',
    },
    padding: 4,
  },
  checked: {},
})((props: CheckboxProps) => <Checkbox {...props} />);

interface CustomSquareCheckboxProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label: string;
  id: string;
  labelStyle?: CSSProperties
}

const CustomSquareCheckbox: React.FC<CustomSquareCheckboxProps> = ({
  checked,
  onChange,
  id,
  label,
  labelStyle
}) => {
  return (
    <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
      <GreenCheckbox
        checked={checked}
        onChange={onChange}
        id={id}
        icon={
          <span
            style={{
              width: 18,
              height: 18,
              border: '1px solid #33820D',
              borderRadius: 0,
              display: 'inline-block',
            }}
          />
        }
        checkedIcon={
          <span
            style={{
              width: 18,
              height: 18,
              border: '1px solid #33820D',
              borderRadius: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxSizing: 'border-box',
            }}
          >
            <span
              style={{
                width: 12,
                height: 12,
                backgroundColor: '#33820D',
              }}
            />
          </span>
        }
      />
      <span style={{
        ...labelStyle,
        marginLeft: 8,
        userSelect: 'none'
      }}>{label}</span>
    </label>
  );
};

export default CustomSquareCheckbox;